@use 'style/utils';
@use './mixins';

$_CLASS-PREFIX: '.joy-pagination';

@mixin ulReset() {
    list-style-type:  none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0;
}

#{$_CLASS-PREFIX} {
    --pagination-focus-color: var(--joy-color-neutral-60);
    --pagination-separator-text-color: var(--joy-color-neutral-60);
    --pagination-cta-color: var(--joy-color-neutral-40);
    --pagination-bg-color-hover: var(--joy-color-secondary-10);
    --pagination-color-hover: var(--joy-color-secondary-50);
    --pagination-bg-color-active: var(--joy-color-secondary-30);

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 20px 0;
    padding: 0;
    list-style-type: none;

    ul {
        @include ulReset();
    }
}

::slotted(ul) {
    @include ulReset();
}

li {
    margin: 0 3px;

    @include mixins.buttonsStyle();

    &#{$_CLASS-PREFIX}__hidden {
        opacity: 0.2;
        pointer-events: none;

        button, a {
            cursor: not-allowed;
        }
    }

    &#{$_CLASS-PREFIX}__arrow {
        @include mixins.arrowsStyle();
    }

    #{$_CLASS-PREFIX}__separator {
        @mixin separator() {
            &::before {
                content: "...";
                position: absolute;
                color: var(--pagination-separator-text-color);
                white-space: nowrap;
                @content;
            }
        }

        &-after {
            margin-right: 30px;

            @include separator() {
                left: calc(100% + 10px);
            }

        }

        &-before {
            margin-left: 30px;
            white-space: nowrap;

            @include separator() {
                right: calc(100% + 10px);
            }
        }
    }

}